module.exports = __webpack_public_path__ + "static/img/29.8a79103.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/29.png
// module id = BmK8
// module chunks = 1